<template>
    <div class="login-layout">
        <headerCustom layout="login" />
        <main class="login">
            <router-view />
        </main>
        <footerMain/>
    </div>
</template>

<script>
import footerMain from '@/components/app/footerMain';
import headerCustom from '@/components/app/headerCustom';

export default {
  name: 'login-layout',
  components:{
    headerCustom, footerMain
  }
};
</script>

<style lang="scss">
@import '~bootstrap/dist/css/bootstrap.min.css';
@import '../assets/sass/app/app.scss';
</style>
